



















































import { Component, Watch } from "vue-property-decorator";

import PickerDialogComponent from "./PickerDialog.vue";

@Component
export default class NumberPickerDialogComponent extends PickerDialogComponent<
  number
> {
  textFieldInput = 0;

  min = 0;
  max = 255;

  @Watch("isPickerOpen")
  onOpen(wasOpened: boolean) {
    if (wasOpened) {
      this.textFieldInput = this.current;
    }
  }

  onSumbit() {
    this.onItemSelected(Math.max(0, Math.min(255, this.textFieldInput)));
  }
}
